import { getAttributionToken, init, report, resetAttribution, resetDevicePrewarm } from './core';

/**
 * 归因 SDK 的组合式入口，与 openinstall 的 useOpenInstall() 用法一致：
 *
 * ```ts
 * const attribution = useAttribution();
 *
 * // 站外场景顶层预热：只采集设备参数，不发上报请求
 * attribution.init();
 *
 * // 用户点击下载按钮时：触发上报（复用预采集结果）并写入归因剪贴板
 * // userSource 不传时会读取 URL 参数 userSource，仍为空则用默认值
 * const handleDownload = () => attribution.report({ userSource: source });
 * ```
 *
 * SDK 内部状态是模块级单例，多次调用 useAttribution() 共享同一份状态。
 */
export function useAttribution() {
  return {
    /** 预采集设备参数，不发上报请求（幂等） */
    init,
    /** 触发上报（复用 init() 的预采集结果）并写入归因剪贴板，需在用户手势内同步调用 */
    report,
    /** 当前已就绪的 token，未就绪或失败时为空 */
    getAttributionToken,
    /** 重置上报状态，用于渠道变化后重新上报（一般不需要调用） */
    resetAttribution,
    /** 清空预采集的设备参数缓存（一般不需要调用） */
    resetDevicePrewarm
  };
}
